/**
 * @file
 * Rotating Image Video functionality.
 *
 * Handles click-to-rotate images and videos in the gallery.
 */

(function (Drupal) {
  'use strict';

  /**
   * Rotating Image Video behavior.
   */
  Drupal.behaviors.rotatingImageVideo = {
    attach: function (context, settings) {
      // Initialize all rotating image galleries
      const galleries = context.querySelectorAll('.rotating-image-gallery');

      galleries.forEach(function (gallery) {
        // Skip if already initialized
        if (gallery.dataset.initialized) {
          return;
        }

        gallery.dataset.initialized = 'true';

        const container = gallery.querySelector('.rotating-image-container');
        const items = gallery.querySelectorAll('.rotating-item');
        const counterCurrent = gallery.querySelector('.current-image');
        const totalItems = items.length;
        let currentIndex = 0;

        // Only initialize if there are multiple items
        if (totalItems <= 1) {
          // If there's only one item and it's a video, load it immediately
          if (totalItems === 1) {
            const videoItem = items[0];
            if (videoItem.dataset.itemType === 'video') {
              loadVideoIframe(videoItem);
            }
          }
          return;
        }

        /**
         * Load video iframe by setting src from data-src
         */
        function loadVideoIframe(item) {
          const iframe = item.querySelector('.youtube-video');
          if (iframe && iframe.dataset.src && !iframe.src) {
            iframe.src = iframe.dataset.src;
          }
        }

        /**
         * Unload video iframe to stop playback
         */
        function unloadVideoIframe(item) {
          const iframe = item.querySelector('.youtube-video');
          if (iframe && iframe.src) {
            // Store the src in data-src if not already there
            if (!iframe.dataset.src) {
              iframe.dataset.src = iframe.src;
            }
            // Remove src to stop video
            iframe.src = '';
          }
        }

        /**
         * Rotate to a specific index
         */
        function rotateTo(newIndex) {
          // Remove active class from current item
          items[currentIndex].classList.remove('active');

          // If current item is a video, unload it
          if (items[currentIndex].dataset.itemType === 'video') {
            unloadVideoIframe(items[currentIndex]);
          }

          // Update index
          currentIndex = newIndex;

          // Add active class to new item
          items[currentIndex].classList.add('active');

          // If new item is a video, load it
          if (items[currentIndex].dataset.itemType === 'video') {
            loadVideoIframe(items[currentIndex]);
          }

          // Update counter
          if (counterCurrent) {
            counterCurrent.textContent = currentIndex + 1;
          }
        }

        // Add click event to rotate items
        container.addEventListener('click', function (e) {
          e.preventDefault();

          // Calculate next index
          const nextIndex = (currentIndex + 1) % totalItems;
          rotateTo(nextIndex);

          // Add a small animation feedback
          container.style.transform = 'scale(0.98)';
          setTimeout(function () {
            container.style.transform = 'scale(1)';
          }, 150);
        });

        // Add keyboard navigation (arrow keys)
        const keydownHandler = function (e) {
          // Only handle if gallery is in viewport
          const rect = gallery.getBoundingClientRect();
          const isInViewport = (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );

          if (!isInViewport) {
            return;
          }

          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();

            // Calculate next/previous index
            let nextIndex;
            if (e.key === 'ArrowRight') {
              nextIndex = (currentIndex + 1) % totalItems;
            } else {
              nextIndex = (currentIndex - 1 + totalItems) % totalItems;
            }

            rotateTo(nextIndex);
          }
        };

        document.addEventListener('keydown', keydownHandler);

        // Store handler reference for potential cleanup
        gallery.keydownHandler = keydownHandler;

        // Preload all images for smooth transitions
        items.forEach(function (item) {
          const img = item.querySelector('img');
          if (img && img.dataset.src) {
            img.src = img.dataset.src;
          }
        });
      });
    }
  };

})(Drupal);
